import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import sidebarHelper from "../../../helpers/sidebar";

export default function ManageFinanceMenu({ openItem, activeItem }) {
  return (
    <li
      className={`nav-item has-treeview 
        ${sidebarHelper.checkOpenItem(openItem, "manage-finance")} `}
    >
      <a
        href="# "
        className={`nav-link  
        ${sidebarHelper.checkActiveItem(openItem, "manage-finance")} `}
      >
        <i className="nav-icon fas fa-money-bill-wave-alt "></i>
        <p>
          مدیریت مالی
          <i className="right fa fa-angle-left"></i>
        </p>
      </a>

      <ul className="nav nav-treeview">
        <li className="nav-item">
          <Link
            to="/finance/manage/ask-transaction/all"
            className={`nav-link  
            ${sidebarHelper.checkActiveItem(
              activeItem,
              "all-ask-transaction"
            )} `}
          >
            <i className="fa fa-image nav-icon"></i>
            <p>درخواست های انتقال موجودی</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/finance/manage/transaction-manually/all"
            className={`nav-link  
          ${sidebarHelper.checkActiveItem(
            activeItem,
            "all-transaction-manually"
          )} `}
          >
            <i className="fa fa-image nav-icon"></i>
            <p>تراکنش دستی</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/finance/manage/all-transaction-score"
            className={`nav-link  
          ${sidebarHelper.checkActiveItem(
            activeItem,
            "all-transaction-score"
          )} `}
          >
            <i className="fa fa-image nav-icon"></i>
            <p>تبدیل امتیاز</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/finance/manage/all-log-wallet-publisher"
            className={`nav-link  
          ${sidebarHelper.checkActiveItem(
            activeItem,
            "all-log-wallet-publisher"
          )} `}
          >
            <i className="fa fa-image nav-icon"></i>
            <p>گزارش تغییرات موجودی کاربر </p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/finance/manage/all-log-score-publisher"
            className={`nav-link  
          ${sidebarHelper.checkActiveItem(
            activeItem,
            "all-log-score-publisher"
          )} `}
          >
            <i className="fa fa-image nav-icon"></i>
            <p>گزارش تغییرات امتیاز کاربر </p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/finance/manage/all-wallet-log-position"
            className={`nav-link  
          ${sidebarHelper.checkActiveItem(
            activeItem,
            "manage-all-wallet-log-position"
          )} `}
          >
            <i className="fa fa-image nav-icon"></i>
            <p>گزارش مالی جایگاه</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/finance/manage/all-score-log-position"
            className={`nav-link  
          ${sidebarHelper.checkActiveItem(
            activeItem,
            "manage-all-score-log-position"
          )} `}
          >
            <i className="fa fa-image nav-icon"></i>
            <p>گزارش امتیاز جایگاه</p>
          </Link>
        </li>
      </ul>
    </li>
  );
}
